<template lang="pug">
v-app
  section
    header.d-flex.row.flex-row.align-items-end.mb-3
      .col-12
        h2.m-0
          i {{$route.name}}
    section
      .d-flex.row.flex-row.mt-4
        .col-12
          .card.p-0.ad_border1-primaryLight.rounded-xl
            .card-body
              h4.mb-3.ad_text-primary
                i Esta Semana
              .card.pt-4.px-3.ad_border1-secondaryLight.rounded-xl(v-for="(me, index) in meetings" :key="me.id")
                .row.d-flex.mb-3.align-items-end
                  .d-flex.col
                    h4.font-weight-bold.mr-1.d-inline-block {{(me) ? me.name: ''}} 
                    span.w-100.text-muted {{(me) ? me.description: ''}}
                  .d-flex.col-auto
                    span.h4.mr-3.mb-0
                      | {{(me) ? moment(me.date_scheduled).utc().format("DD/MM/YYYY") : '' }}
                    router-link.btn.btn-secondary.px-3(:to="{name: 'Ejecutar Diálogo de Desempeño', params: { id:me.id } }")
                      | Ejecutar
                .col-12.py-2.rounded-lg.ad_bg-gray.mb-3
                  .d-flex.row
                    .col-12
                      table.w-100.table-rounded-body
                        thead
                          tr
                            th.font-weight-bold(colspan="3") Objetivos
                            th
                        tbody
                          tr(v-for="(obj, i) in me.objectives" :key="obj.id" :class="{'border-bottom' : i != me.objectives.length - 1}")
                            td.py-3(width='15%')
                              div
                                a(:id='"group-obj-" + i + index')
                                  i.icon-letters.icon-letters__viaje.mr-1(v-if="obj.travel") V
                                  i.icon-letters.icon-letters__producto.mr-1(v-if="obj.product") P
                                  i.icon-letters.icon-letters__segmento.mr-1(v-if="obj.segment") S
                                b-tooltip(:target='"group-obj-" + i + index' , placement='top')
                                  | {{obj.travel ? obj.travel.name : ''}} - {{obj.product ? obj.product.name : ''}} - {{obj.segment ? obj.segment.name : ''}}
                            td.py-3(width='30%')
                              div
                                i.icon-letters.icon-letters__negocio.mr-1 N
                                | {{obj.business_type ? obj.business_type.name : ' ' | truncate(50, '...')}}
                            td.py-3
                              div
                                i.icon-letters.icon-letters__kpi.mr-1 A
                                | {{obj.kpi ? obj.kpi.name : '' | truncate(50, '...')}}
                            td.py-3.text-right(width='30')
                              div
                                a.no-decoration(title="Comentarios" @click.stop='openObjDetail(obj._id)')
                                  i.icono.icono-comentarios.ad_text-primary
    section(v-show="historial")
      .d-flex.row.flex-row.mt-4
        .col-12
          .card.p-0.ad_border1-primaryLight.rounded-xl
            .card-body
              h4.mb-3.ad_text-primary
                i Historial
              .row.flex-row.d-none
                .col-10
                  .row
                    .form-group.col-4
                      .ad_select
                        select(v-model='selected')
                          option(:value="null" disabled) Campo de selección
                          // option(:value="dummy.value" v-for="dummy in dummys") {{dummy.value}}
                    .form-group.col-4
                      .ad_select
                        select(v-model='selected')
                          option(:value="null" disabled) Campo de selección
                          // option(:value="dummy.value" v-for="dummy in dummys") {{dummy.value}}
                    .form-group.col-4
                      input.form-control(type="text" placeholder="Campo de texto")
                .col-10
                  .row
                    .form-group.col-4
                      .ad_select
                        select(v-model='selected')
                          option(:value="null" disabled) Campo de selección
                          // option(:value="dummy.value" v-for="dummy in dummys") {{dummy.value}}
                    .form-group.col-4
                      .ad_select
                        select(v-model='selected')
                          option(:value="null" disabled) Campo de selección
                          // option(:value="dummy.value" v-for="dummy in dummys") {{dummy.value}}
                    .form-group.col-4
                      input.form-control(type="text" placeholder="Campo de texto")
                .col-2
                  button.btn.btn__medium.btn-secondary(@click.prevent='loadHistory')
                    | Aplicar

              .row.mt-3(v-show="historial")
                .col-12
                  b-table.w-100.text-center.table-simple(
                    show-empty
                    stacked="md"
                    :items='meetingsHistory',
                    :fields="fields",
                    :sort-compare= "dateSorter",
                    :current-page="0",
                    :sort-by="sortBy",
                    :sort-desc="sortDesc",
                    :per-page="perPage")
                    template(slot='assistants', slot-scope='row')
                      a.ad_text-primary.ml-2(href="#" title="Asistentes" :id="'user-' + row.index")
                        i.far.fa-user-circle.fa-1x.align-top
                      b-tooltip(:target="'user-' + row.index" , placement='top')
                        div(v-for="(value, name, index) in row.item.assistantsTooltip") {{value}}
                    template(slot='view', slot-scope='row')
                      router-link(:to="{path:'/dialogo-desempeno/'+row.item.id+'/detail'}" append)
                        i.icono.icono-ver.ad_text-primary.align-top
                  b-pagination(
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage",
                    @input="selectedPage()",
                    class="my-0")


  v-navigation-drawer(v-model='drawer', app='', temporary='', right='', width='500')
    header.ad_bg-primary.pt-5.pb-2.px-4
      h3.text-white.mt-4
        i Comentarios
    section.py-4.px-2.overflowy-auto
      .row.mx-0.align-items-end
        .col
          label
            a(id="viajecomobj")
              i.icon-letters.icon-letters__viaje V
              i.icon-letters.icon-letters__producto.mx-1 P
              i.icon-letters.icon-letters__segmento S
            b-tooltip(target="viajecomobj" , placement='top')
              | {{(objective) ? objective.travel.name : ''}} + {{(objective) ? objective.product.name : ''}} + {{(objective) ? objective.segment.name : ''}}
            a(id="negociocomobj")
              i.icon-letters.icon-letters__negocio.ml-1 N
            b-tooltip(target="negociocomobj" , placement='top')
              | {{(objective) ? objective.business_type.name : ''}}
          label
            i.icon-letters.icon-letters__kpi.mr-1 A
            | {{(objective) ? objective.kpi.name : ''}}

        
        .col-auto
          p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
            sup Registro
            span.ad_text-grayDark 60%
          p.d-inline-block.mb-0.ad_text-grayMedio
            sup Meta
            span 90%
      .col-12.mt-4
        .form-group.mt-4
          textarea.form-control(placeholder='Agregar comentario', rows='3', v-model='comment')
        .form-group.justify-content-between
          button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="drawer = false")
            i.far.fa-times-circle.fa-1x.mr-1.align-bottom
            | Cancelar
          button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="addCommentToObjective(objective._id)")
            | Agregar comentario
            i.fas.fa-chevron-right.fa-1x.ml-1.align-bottom

        hr.my-4
        
        h3.ad_text-grayMedio.mb-3
          i Anteriores
        div(v-if="objective")        
          .row.mb-3(v-for='comm in objective.comments')
            .col-4.pr-0
              p.font-weight-bold.m-0 {{comm.user}}
              small.d-block {{comm.date | DateFormat}}
              small.d-block {{comm.date | HourFormat}} hrs.
            .col-8.pl-0
              .dialog-box
                p {{comm.text}}  
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";

export default {
  name: "DialogoDesempenoHome",
  components: {},
  data() {
    return {
      sortBy: "executionDate",
      sortDesc: true,
      historial: true,
      selected: null,
      drawer: null,
      plan: null,
      comments: null,
      drawer: false,
      objective: null,
      meetings: [],
      meetingsHistory: [],
      meetingtypes: [],
      comment: null,
      filter: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      fields: [
        { key: "executionDate", label: "Ejecución", sortable: true },
        { key: "description", label: "Descripción", sortable: true },
        { key: "objectivesCount", label: "Objs", sortable: true },
        { key: "assistants", label: "Asistentes", sortable: true },
        { key: "actionsCount", label: "Compromisos", sortable: true },
        { key: "opportunitiesProblemsCount", label: "Prob/Oport" },
        { key: "view", label: "Ver" }
      ]
    };
  },
  methods: {
    moment,
    ...mapActions("objective", [
      "addComment",
      "commentsById",
      "getObjectiveById"
    ]),
    ...mapActions("plan", ["planByWeek"]),
    ...mapActions("meeting", ["getMeetingsByPlan", "getClosedMeetingsByUser"]),
    dateSorter(a, b, key) {
      if (key !== "executionDate") {
        return null; // or false
      }
      let aDate = moment(a[key], "DD/MM/YYYY");
      let bDate = moment(b[key], "DD/MM/YYYY");
      if (aDate.isValid && bDate.isValid) {
        if (aDate < bDate) {
          return -1;
        } else if (aDate > bDate) {
          return 1;
        } else {
          return 0;
        }
      }
      return null;
    },
    loadPlan() {
      const vm = this;
      const loading = vm.$toast.loading("Cargando DDD...");
      vm.planByWeek({ date: new Date(moment()), id: vm.user.id }).then(
        plan => {
          vm.plan = plan;
          plan === null ? loading.hide() : null;
          vm.getMeetingsByPlan(vm.plan._id)
            .then(
              response => {
                vm.meetings = response;
                loading.hide();
              },
              error => {
                vm.$notify({
                  type: "danger",
                  title: "Notificación",
                  content: error.payload.message,
                  closeable: true,
                  duration: 5000
                });
              }
            )
            .catch(err => {
              loading.hide();
              vm.$notify({
                type: "danger",
                title: "No existe plan para esta semana",
                content: error.payload.message,
                closeable: true,
                duration: 5000
              });
            });
        },
        error => {
          vm.$notify({
            type: "danger",
            title: "Notificación",
            content: error.payload.message,
            closeable: true,
            duration: 5000
          });
        }
      );
    },
    loadHistory() {
      const vm = this;
      const loading = vm.$toast.loading("Cargando Histórico DDDs...");
      vm.getClosedMeetingsByUser({id: vm.user.id, pagination: {page: vm.currentPage, perPage: vm.perPage}}).then(
        response => {
          vm.currentPage = response.page
          vm.totalRows = response.total 
          vm.meetingsHistory = response.docs                  
        },
        error => {
          vm.$notify({
            type: "danger",
            title: "Notificación",
            content: error.payload.message,
            closeable: true,
            duration: 5000
          });
        }
      );
      loading.hide();
    },
    openObjDetail(id) {
      const vm = this;
      vm.getObjectiveById(id).then(
        () => {
          vm.objective = vm.$store.getters["objective/getObjective"];
          vm.objective.comments = vm.objective.comments.reverse();
          vm.drawer = !vm.drawer;
        },
        error => {
          vm.$notify({
            type: "danger",
            title: "Notificación",
            content: error.payload.message,
            closeable: true,
            duration: 5000
          });
        }
      );
    },
    commentsByObjective() {
      const vm = this;
      vm.commentsById(id).then(
        () => {
          vm.comments = vm.$store.getters["commentsById/getComments"];
          vm.comments = vm.comments.reverse();
        },
        error => {
          vm.$notify({
            type: "danger",
            title: "Notificación",
            content: error,
            closeable: true,
            duration: 5000
          });
        }
      );
    },
    addCommentToObjective(id) {
      const vm = this;
      if (vm.comment === null) {
        vm.$notify({
          type: "danger",
          title: "Notificación",
          content: "Porfavor agregue una descripcion al comentario",
          closeable: true,
          duration: 5000
        });
      } else {
        let comm = {
          user: vm.user.name,
          date: moment(),
          text: vm.comment
        };
        vm.addComment({
          id: id,
          comment: comm
        }).then(
          () => {
            vm.objective.comments.push(comm);
            vm.objective.comments = vm.objective.comments.reverse();
            vm.comment = null;
            vm.drawer = false;
          },
          error => {
            vm.$notify({
              type: "danger",
              title: "Notificación",
              content: error.payload.message,
              closeable: true,
              duration: 5000
            });
          }
        );
      }
    },
    selectedPage() {
      const vm = this
      vm.loadHistory()
    }
  },
  watch: {
    moveobjetivo: function() {
      let moveobjetivo = this.moveobjetivo;
      if (this.moveobjetivo === true) {
        this.$emit("can-continue", { value: true });
        this.$emit("completed-step", { value: true });
      } else {
        this.$emit("can-continue", { value: false });
      }
    },
    drawer: function() {
      this.$parent.overlay = !this.$parent.overlay;
      this.$emit("clase", this.$parent.overlay);
      const el = document.querySelector(".overlay");

      if (this.$parent.overlay) {
        el.classList.add("open");
      } else {
        el.classList.remove("open");
      }
    }
  },
  mounted() {
    const vm = this;
    const loading = vm.$toast.loading("Cargando datos...");
    vm.user = vm.$store.getters["auth/getUserInfo"];
    vm.loadPlan();
    vm.loadHistory();
    loading.hide();
    this.$emit("can-continue", { value: true });
  }
};
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/views/dialogo-desempeno-home.vue